/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td
export const tableDetail = {
    entity: 'customerProfit',//name table on the db
    dest: 'customerProfit',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail: `data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"customerProfit", "elem":"fullcont", "id":"customerProfit-fullcont", "act":"callData", "dbid": "#dbid"},
                                            {"dest":"customerProfit", "elem":"fullcont", "id":"customerProfit-fullcont", "act":"callUnpaidInvoices", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{"dest":"customerProfit", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"report", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields: [""],
        mainFilterValues: ["", ""],
        andFilterFields: [""],
        andFilterValues: [""],
    }

}

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data) { //console.log('organizeRow>')

    var newData = []

    if (data.length === 0) {
        newData.push({
            id: 'nothing', colum: [{ label: 'No Results', span: '' },
            { label: '', span: '' },
            { label: '', span: '' },]
        })
        return newData
    }

    data.forEach((elem) => {
        newData.push(
            {
                id: elem.customer_id, colum: [{
                    label: elem.customer_name,
                    span: elem.total_earnings,
                    style: {
                        tdClass: "tdWithAvatar",
                        avatar: elem.avatar,
                        avatarColor: elem.avatarColor,
                        avatarColorLetter: elem.avatarColorLetter,
                        avatarLetter: elem.avatarLetter,
                    }
                },
                { label: elem.last_24_hours, span:elem.last_24_hours_income, style:{
                    tdClass:'tdWithIcon td-blue-icon',
                    svg:'./css/svg.svg#warning'
                } },
                { label: elem.last_7_days, span:elem.last_7_days_income, style:{
                    tdClass:'tdWithIcon td-green-icon',
                    svg:'./css/svg.svg#warning'
                } },
                { label: elem.last_15_days, span:elem.last_15_days_income, style:{
                    tdClass:'tdWithIcon td-yellow-icon',
                    svg:'./css/svg.svg#warning'
                } },
                { label: elem.last_30_days, span:elem.last_30_days_income, style:{
                    tdClass:'tdWithIcon td-orange-icon',
                    svg:'./css/svg.svg#warning'
                } },
                { label: elem.last_90_days, span:elem.last_90_days_income, style:{
                    tdClass:'tdWithIcon td-red-dark-icon',
                    svg:'./css/svg.svg#warning'
                } },
                { label: elem.over_90_days, span:elem.over_90_days_income, style:{
                    tdClass:'tdWithIcon td-fuchsia-icon',
                    svg:'./css/svg.svg#warning'
                } },
                ]
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/